import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import CapitalChangeListSkeleton from '@components/Group/Portfolio/Skeleton/CapitalChangeListSkeleton';

const CapitalChangeList = lazy(
  () => import('@components/Group/Portfolio/CapitalChangeList')
);

/** 조합 관리 > 상세 > 포트폴리오 상세 > 자본금 변동내역 */
const CapitalChange = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<CapitalChangeListSkeleton />}>
          <CapitalChangeList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default CapitalChange;
